<template>
<section class="product-card-meb p-2">
    <div class="row product-item-wrapper" >
            <!-- <div class="col-lg-4 col-md-4 col-sm-4 mx-0 product-item stretch-card" v-for="(item, itemID) in items" :key="itemID">
                <div class="card">
                    <div class="card-body">
                        <div class="product-img-outer">
                            <img  class="product_image" :src="item['card-image-url']" alt="prduct image">
                        </div>
                        <div>
                            
                        </div>
                        <p class="product-title">Vernis à ongle</p>
                        <span class="product-description d-flex justify-content-between">
                            <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. </p>
                            <h2 class="text-muted">5€</h2>
                        </span>
                    </div>
                </div>
            </div> -->

            <!-- /test -->
            <div class="col-4 my-3 " v-for="(item, itemID) in items" :key="itemID">
                <div class="card">
                    <img class="card-img-top" src="@/assets/images/import/cosmetique.png" alt="Card image cap">
                    <div class="card-body p-3">
                        <h5 class="card-title">Vernis à ongle</h5>
                        <div class="d-flex justify-content-between">
                            <p class="card-text">Lorem, ipsum dolor sit amet consectetur adipisicing elit</p>
                            <h2 class="text-muted">7€</h2>
                        </div>
                    </div>
                </div>
            </div>
    </div>
</section>
</template>

<script>
import axios from 'axios'
export default {
    name: 'product-card-meb',
    components: {

    },
    data () {
        return {
            items: []
        }
    },
    props: {
        id: String,
        scrollcards: Boolean,
        entitytype: String,
        card: Array,
        title: String,
        description:String,
        price: String,
        column: String,
        sectionTitle: String,
        editable: Boolean
    },
    methods: {
        getEntitytype () {
            if(this.entitytype) {
                axios.get(`https://sites.comolapapaya.com/${this.entitytype}`)
                .then ( resEntitytype => {
                    this.items= resEntitytype.data.result
                })
                .catch ( errEntitytype => {console.log(errEntitytype)})
            }else if(this.card){
                this.items = this.card
            }else{
                this.items=[]
            }
        },
        //scrollcards
        scrollright() {
            console.log(this.id);
            document.getElementById(`${this.id}`).scrollLeft += 1000;
        },
        scrollleft() {
            console.log(this.id);
            document.getElementById(`${this.id}`).scrollLeft -= 1000;
        },
        deleteCard(item) {
            let index = this.items.indexOf(item)
            console.log(index)
            this.items.splice(index, 1)
        }
        // edit(item) {
        //     this.$emit('edit-card', {
        //         item: item
        //     })
        // }
    },
    mounted () {
        this.getEntitytype ()
    }
}
</script>

<style scoped>
.product-item{
    display: inline-block;
    text-decoration: none;
    height: auto; 
    width: 288px;
}

/* scrollcards */
 .scrollcards {
  /* background-color: #fff; */
  overflow-x: auto;
  white-space: nowrap;
}

/* ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    background: transparent;
} */

.scrollcards {
    scrollbar-width: thin
}

div.scrollcards .card {
    display: inline-block;
    /* padding: 14px; */
    text-decoration: none;
    height: auto; 
    width: 300px;
}


.carousel-control-prev-icon {
    background-image: url('../../assets/images/import/arrow-preview.png');
    width: 50px;
    height: 50px;
    margin: 0px 81px 0px -122px
    }
.carousel-control-next-icon {
    background-image: url('../../assets/images/import/arrow-next.png');
    width: 50px;
    height: 50px;
    margin: 0px -121px 0px 79px
    }

img {
    width: auto;
    height: 200px;
    object-fit: cover;
}

/* product-card-meb only */
.product-card-meb {
    border: black 1px solid;
}
.card-body{
    border: black 1px solid;
}
</style>